const ValidationTypes = {
  ERROR: "error",
  WARNING: "warning",
  NONE: ""
} as const;

const ALL = Object.values(ValidationTypes);

export default { ...ValidationTypes, ALL };
